/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Reverse_One_FrameInputs */

const en_shortcut_keys_desc_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go back one frame in the video`)
};

const fr_shortcut_keys_desc_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reculer d'une image dans la video`)
};

const de_shortcut_keys_desc_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spule im Video ein Bild zurück.`)
};

const it_shortcut_keys_desc_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna indietro di un fotogramma nel video`)
};

const ru_shortcut_keys_desc_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вернитесь на один кадр назад в видео.`)
};

const es_shortcut_keys_desc_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retroceda un fotograma en el vídeo`)
};

const zh_cn2_shortcut_keys_desc_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回到视频的上一帧。`)
};

const ja_shortcut_keys_desc_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオを1フレーム戻す`)
};

const hi_shortcut_keys_desc_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो में एक फ्रेम पीछे जाएं`)
};

const pt_pt2_shortcut_keys_desc_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volte um fotograma no vídeo.`)
};

/**
* | output |
* | --- |
* | "Go back one frame in the video" |
*
* @param {Shortcut_Keys_Desc_Reverse_One_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_reverse_one_frame = /** @type {((inputs?: Shortcut_Keys_Desc_Reverse_One_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Reverse_One_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_reverse_one_frame(inputs)
	if (locale === "de") return de_shortcut_keys_desc_reverse_one_frame(inputs)
	if (locale === "it") return it_shortcut_keys_desc_reverse_one_frame(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_reverse_one_frame(inputs)
	if (locale === "es") return es_shortcut_keys_desc_reverse_one_frame(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_reverse_one_frame(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_reverse_one_frame(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_reverse_one_frame(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_reverse_one_frame(inputs)
	return en_shortcut_keys_desc_reverse_one_frame(inputs)
});